"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var select_1 = require("../select");
function factory(items) {
    return function (_a) {
        var hour = _a.hour, defaultHour = _a.defaultHour, others = tslib_1.__rest(_a, ["hour", "defaultHour"]);
        return React.createElement(select_1.default, tslib_1.__assign({ style: { minWidth: "auto" }, items: items, maxItems: 8, placeholder: "__:__" }, others, { value: hour, defaultValue: defaultHour }));
    };
}
exports.default = factory;
